/*
 * «Ahora en la tienda» (portada de cada imprenta, /print/{slug}): pinchar la foto de un aviso la abre ENTERA y en grande en el
 * <dialog> de pieces/highlights.blade.php. La tarjeta la recorta a 4:3, y uno de los avisos de una tienda real es un QR que el
 * cliente enseña en el mostrador: aquí se ve completo, en el mayor derivado que exista.
 *
 * Lo demás lo hace el navegador: <dialog> modal (foco dentro, Esc lo cierra, el resto de la página inerte) y el zoom con los
 * dedos, que es el de la página (el viewport lo permite y aquí no se toca `touch-action`).
 *
 * Sin este fichero, o en un navegador sin <dialog>, el enlace abre el JPG mayor tal cual.
 */
const dialog = document.getElementById('pfs-zoom');
const stage = dialog ? dialog.querySelector('[data-pfs-zoom-stage]') : null;
const OPEN_CLASS = 'pfs-zoom-open';

/** El mayor ancho (`800w` → 800) de un srcset, o 0. */
const largestWidth = (srcset) => Math.max(0, ...[...String(srcset || '').matchAll(/\s(\d+)w\b/g)].map((m) => Number(m[1])));

if (dialog && stage && typeof dialog.showModal === 'function') {
    let trigger = null;

    const open = (link) => {
        const picture = link.querySelector('picture');
        const original = picture ? picture.querySelector('img') : null;
        if (!original) return false;

        const copy = picture.cloneNode(true);
        const img = copy.querySelector('img');
        // `sizes` igual al mayor derivado: el navegador elige siempre el fichero más grande (es lo que se amplía con los dedos) y
        // el CSS lo encoge a lo que quepa en la pantalla.
        const sizes = `${largestWidth(original.getAttribute('srcset')) || 800}px`;
        copy.querySelectorAll('source, img').forEach((el) => el.setAttribute('sizes', sizes));
        // El ancho y alto de la tarjeta son los de su marco 4:3, no los de la foto: sin ellos manda la proporción real.
        img.removeAttribute('width');
        img.removeAttribute('height');
        img.loading = 'eager';
        img.alt = link.dataset.pfsZoomTitle || '';

        stage.replaceChildren(copy);
        dialog.setAttribute('aria-label', link.dataset.pfsZoomTitle || 'Imagen ampliada');
        trigger = link;
        document.documentElement.classList.add(OPEN_CLASS);
        dialog.showModal();

        return true;
    };

    document.querySelectorAll('a[data-pfs-zoom]').forEach((link) => {
        link.setAttribute('aria-haspopup', 'dialog');
        link.addEventListener('click', (event) => {
            // Ctrl, Mayús, Cmd o la rueda: abrir el JPG en otra pestaña, como cualquier enlace.
            if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
            if (open(link)) event.preventDefault();
        });
    });

    // Un toque fuera de la foto: en el fondo oscuro (el propio <dialog>) o en el hueco que la rodea. Sobre la foto no cierra.
    dialog.addEventListener('click', (event) => {
        if (event.target === dialog || event.target === stage) dialog.close();
    });

    // Cualquier cierre (Esc, «✕», toque fuera, atrás en Android) pasa por aquí: devolver el scroll y el foco a la foto pinchada.
    dialog.addEventListener('close', () => {
        document.documentElement.classList.remove(OPEN_CLASS);
        stage.replaceChildren();
        if (trigger) trigger.focus({ preventScroll: true });
        trigger = null;
    });
}
